import _ from "lodash";
import React from "react";
import {
  FilterLabelButton,
  ChecklistDropdown,
  Button,
  Badge,
} from "@toddle-edu/ds-web";
import {
  StaffMemberOutlined,
  StudentOutlined,
  FamilyOutlined,
  FilterOutlined,
  UserProfileOutlined,
} from "@toddle-edu/ds-icons";
import { STAFF, STUDENT, PARENT } from "Constants/stringConstants";
import { useI18n } from "Hooks";
import classNames from "classnames";
import { getLabelValueForMultiFilterLabelButton } from "Utils";
import classes from "./UserTypeFilter.scss";
import { isMessagingRevempEnabled } from "MessagingV2/modules/Utils";

const UserTypeFilter = ({ onOptionsSelected, values = [] }) => {
  const { t } = useI18n(["common"]);
  const isUIRevempEnabled = isMessagingRevempEnabled();

  const userTypeOptions = [
    {
      value: "DIVIDER",
      isDivider: true,
    },
    {
      value: STAFF,
      label: t("common:staff_members_plural"),
      prefixElement: (
        <StaffMemberOutlined variant={"subtle"} size={"xx-small"} />
      ),
    },
    {
      value: STUDENT,
      label: t("common:student_plural"),
      prefixElement: <StudentOutlined variant={"subtle"} size={"xx-small"} />,
    },
    {
      value: PARENT,
      label: t("common:family_member_plural"),
      prefixElement: <FamilyOutlined variant={"subtle"} size={"xx-small"} />,
    },
  ];

  return (
    <div className={classes.filterContainer}>
      <ChecklistDropdown
        allOptionPrefix={
          <UserProfileOutlined size={"xx-small"} variant="subtle" />
        }
        allOptionLabel={t("common:all")}
        options={userTypeOptions}
        showAllOption={true}
        value={values}
        onChange={onOptionsSelected}
        showSelectedOptionsOnTop={false}
        checklistContainerClassName={classes.dropDownClass}
      >
        {isUIRevempEnabled ? (
          <Button
            icon={<FilterOutlined />}
            size="small"
            variant="neutral"
            type="outlined"
            dsVersion="2.0"
            className={classNames(classes.filterButton, {
              [classes.filterButtonWithBadge]: _.size(values),
            })}
          >
            {_.size(values) ? (
              <Badge type="numeric" value={_.size(values)} variant={"filter"} />
            ) : null}
          </Button>
        ) : (
          <FilterLabelButton
            size={"medium"}
            variant={"inline"}
            label={t("common:usertype_lowercase")}
            labelValue={getLabelValueForMultiFilterLabelButton({
              selectedOptions: values,
              options: userTypeOptions,
              t,
              noneText: t("common:all"),
            })}
          />
        )}
      </ChecklistDropdown>
    </div>
  );
};

export default UserTypeFilter;
